import { IPolicy, IPolicyDetail } from '@verzekeringapp-mono/shared/src/models/policy'
import { isPolicyVehicle } from '@verzekeringapp-mono/shared/src/utils/policy_utils'

type SummaryPolicy = Pick<IPolicy, 'details' | 'productId' | 'productName' | 'policyNumber'>

const toDetailText = (value: unknown): string => {
  if (typeof value === 'string') return value.trim()
  if (typeof value === 'number' && Number.isFinite(value)) return String(value)

  return ''
}

const detailText = (detail?: IPolicyDetail) =>
  toDetailText(detail?.code) || toDetailText(detail?.value)

export const getPolicySummary = (policy: SummaryPolicy): string => {
  const details = Object.values(policy.details || {})
  const findDetail = (name: string) => detailText(details.find(detail => detail.name === name))
  const findByLabel = (pattern: RegExp) => detailText(details.find(detail =>
    pattern.test(`${detail.name} ${detail.label}`.replace(/_/g, ' '))
  ))

  // These vehicles are distinguished by their make, even if they have a plate.
  if ([68, 71].includes(Number(policy.productId))) {
    return findByLabel(/\b(brand|make|merk)\b/i) || policy.policyNumber
  }

  if (isPolicyVehicle(policy.productId)) {
    return findDetail('license_plate') || policy.policyNumber
  }

  if (/boot|vaartuig|rechtsbijstand/i.test(policy.productName)) {
    return policy.policyNumber
  }

  if (/woonhuis|inboedel|opstal/i.test(policy.productName)) {
    const zipCode = findDetail('zip_code')
    const houseNumber = findDetail('house_number')

    return zipCode && houseNumber ? `${zipCode} | ${houseNumber}` : policy.policyNumber
  }

  if (/reis|aansprakelijk|ongevallen/i.test(policy.productName)) {
    const household = findByLabel(/family|household|gezin|samenstelling|verzekerden|verzekeringsvorm/i) ||
      detailText(details.find(detail => /^(gezin|alleenstaand)$/i.test(detailText(detail))))

    return household || policy.policyNumber
  }

  return policy.policyNumber
}
